import { useState } from "react";
import { Button, Tooltip } from "antd";
import { CloseOutlined, BarChartOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { ChatModule, DashboardModule } from "@medipha/chat";
import "@medipha/chat/styles.css";
import "./override.css";
import useChatRuntimeProps from "./useChatRuntimeProps";

// Ruột của chat (thanh điều khiển + ChatModule), dùng chung cho modal và trang /app/chat-erp.
// Chiếm trọn chiều cao thẻ cha -> nơi dùng tự quyết định kích thước/vị trí panel.
const ChatSurface = ({ onClose }) => {
  const [showDashboard, setShowDashboard] = useState(false);
  const {
    userId: chatUserId,
    hasAddGroupVerified,
    hasUpdateGroupVerified,
    hasDeleteGroupVerified,
    hasViewGroupVerified,
    ...chatRuntimeProps
  } = useChatRuntimeProps();

  // Chỉ user có quyền trên nhóm chat "tích xanh" mới thấy nút dashboard.
  const canViewDashboard =
    hasAddGroupVerified ||
    hasUpdateGroupVerified ||
    hasDeleteGroupVerified ||
    hasViewGroupVerified;

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <div
        style={{
          flex: "none",
          height: 48,
          padding: "0 8px 0 16px",
          borderBottom: "1px solid #f0f0f0",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <span style={{ fontWeight: 600 }}>
          {showDashboard ? "Dashboard Chat" : "Meditech Chat"}
        </span>
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          {canViewDashboard && (
            <Tooltip title={showDashboard ? "Về Chat" : "Dashboard"}>
              <Button
                type="text"
                icon={showDashboard ? <ArrowLeftOutlined /> : <BarChartOutlined />}
                onClick={() => setShowDashboard((prev) => !prev)}
              />
            </Tooltip>
          )}
          <Tooltip title="Đóng">
            <Button type="text" icon={<CloseOutlined />} onClick={onClose} />
          </Tooltip>
        </div>
      </div>

      {/* minHeight:0 để vùng chat co theo flex thay vì tràn ra ngoài panel */}
      <div style={{ flex: 1, minHeight: 0, overflow: showDashboard ? "auto" : "hidden" }}>
        {showDashboard ? (
          <DashboardModule
            accessToken={chatRuntimeProps.accessToken}
            apiUrl={chatRuntimeProps.apiUrl}
            stickerBaseUrl={chatRuntimeProps.stickerBaseUrl}
            canViewDashboard={canViewDashboard}
            onUnauthorized={chatRuntimeProps.onUnauthorized}
            onRefreshToken={chatRuntimeProps.onRefreshToken}
          />
        ) : (
          chatUserId && (
            // key: đổi người dùng (đăng nhập tài khoản khác mà không F5) thì mount lại hẳn, vì
            // ChatModule không phản ứng với userId đổi giữa đường (xem giải thích ở trên).
            <ChatModule
              key={chatUserId}
              userId={chatUserId}
              hasAddGroupVerified={hasAddGroupVerified}
              hasUpdateGroupVerified={hasUpdateGroupVerified}
              hasDeleteGroupVerified={hasDeleteGroupVerified}
              {...chatRuntimeProps}
            />
          )
        )}
      </div>
    </div>
  );
};

export default ChatSurface;
